import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { paramCheck, requiredParamsCheck } from '../../utils';

export interface GetBLEDeviceServicesOption
  extends Partial<GeneralInvokeOption> {
  deviceId: string;
  invalidParamObj?: '';
}

// 获取蓝牙低功耗设备所有服务 (service)
export function getBLEDeviceServices(option: GetBLEDeviceServicesOption) {
  if (
    !requiredParamsCheck(
      { deviceId: option.deviceId },
      option,
      APINames.Native.GET_BLE_DEVICE_SERVICES
    )
  ) {
    return option.invalidParamObj;
  }
  if (
    paramCheck(APINames.Native.GET_BLE_DEVICE_SERVICES, option, {
      deviceId: ''
    })
  ) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.GET_BLE_DEVICE_SERVICES,
      option
    );
  }
  return option.invalidParamObj;
}
